// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 15:26:36
import { PersistentObject } from '../../SagaBase/PersistentObject';
import * as SagaBase from '../../SagaBase';
import { Guid, GuidTools } from '@models/guid';

export abstract class AlternateUserProfile_abstract extends PersistentObject {
  static $t: string = 'SagaBase.AlternateUserProfile';
  $t: string = 'SagaBase.AlternateUserProfile';

  public static GetMembers(): string[] {
    return [
      'ObjId',
      'UserId',
      'ApplicationProfileId',
      'SiteId',
      'ApplicationAccessConst',
      'ApplicationName',
      'SiteName',
      'AccessName',
      'ProfileName'
    ].concat(PersistentObject.GetMembers());
  }

  public GetMembers(): string[] {
    return AlternateUserProfile_abstract.GetMembers();
  }

  public _init(): void {
    super._init();
    //// Add "NO-" before "AUTO_INIT_CODE" if don't want to re-generate at each compilation
    ///*<AUTO_INIT_CODE>*/

    ///*</AUTO_INIT_CODE>*/
  }

  // Add "NO-" before "INSTANCE_MEMBERS" if don't want to re-generate at each compilation
  /*<INSTANCE_MEMBERS>*/

  public ObjId: any;
  public UserId: number = 0;
  public ApplicationProfileId: number = 0;
  public SiteId: number;
  public ApplicationAccessConst: number = 0;
  public ApplicationName: string;
  public SiteName: string;
  public AccessName: string;
  public ProfileName: string;

  /*</INSTANCE_MEMBERS>*/

  // Add "NO-" before "AUTO_IMPLEMENTATION" if don't want to re-generate at each compilation
  /*<AUTO_IMPLEMENTATION>*/

  get ParentObjId(): any {
    return null;
  }
  set ParentObjId(value: any) {}

  /*</AUTO_IMPLEMENTATION>*/
}
